import { Alert,
    AlertDescription,
    AlertTitle,
    Badge,
    Box,
    CloseButton,
    DarkMode,
    Stack
} from "@chakra-ui/react"

const statusToText = (level) => level === 'WARN' ? 'Warning' : level === 'ERROR' ? 'Error' : 'Info'
const statusToBackgroundColor = (status) => status === 'WARN' ? 'yellow.700' : status === 'ERROR' ? 'red.700' : 'green.700'
const statusToBadgeColorScheme = (status) => status === 'WARN' ? 'yellow' : status === 'ERROR' ? 'red' : 'green'

export const NotificationToast = ({title, description, children, onClose, status = 'ERROR', count = undefined, ...rest}) => {
    return (
        <Alert
            borderRadius={5}
            alignItems='start'
            padding='16px 20px 20px 20px'
            background={statusToBackgroundColor(status)}
            color='white'
            marginY={3}
            {...rest}
        >
            <Stack width='100%' spacing={3}>
                <Box>
                    <DarkMode>
                        <AlertTitle
                            textAlign='left'
                            fontSize='lg'
                            paddingRight={8}
                        >
                            {count && <Badge colorScheme={statusToBadgeColorScheme(status)} variant='solid'>{count}</Badge>} <Badge colorScheme={statusToBadgeColorScheme(status)} variant='solid'>{statusToText(status)}</Badge> {title}
                        </AlertTitle>
                    </DarkMode>
                    <AlertDescription>
                        {description}
                    </AlertDescription>
                </Box>
                {children}
            </Stack>
            <CloseButton
                fontSize='10px'
                width='24px'
                height='24px'
                position='absolute'
                right='var(--chakra-space-2)'
                top='var(--chakra-space-2)'
                onClick={onClose}
            />
        </Alert>
    )
}

export const ErrorToast = ({title, status = 'ERROR', ...rest}) => <NotificationToast title={title} status={status} {...rest} />
